var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import crypto from "crypto-browserify";
var cacheWraperAxios = function (axios) {
    var cacheContainer = {};
    var unCacheMethods = {};
    var get = axios.get.bind(axios);
    for (var key in axios) {
        unCacheMethods[key] = axios[key];
    }
    axios.get = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (args && args.length > 1 && args[1] && args[1].cache) {
            var hash = crypto.createHash("sha1");
            hash.update(JSON.stringify(args));
            var cache_1 = cacheContainer[hash.digest()];
            if (cache_1) {
                return new Promise(function (resolve, reject) {
                    resolve(__assign({ __fromAxiosCache: true }, cache_1));
                });
            }
            else {
                var promise = get.apply(void 0, args);
                promise.then(function (res) {
                    var hash = crypto.createHash("sha1");
                    hash.update(JSON.stringify(args));
                    cacheContainer[hash.digest()] = res;
                });
                return promise;
            }
        }
        return get.apply(void 0, args);
    };
};
export default cacheWraperAxios;
